import { Component, Inject, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DatePipe, NgClass } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router, RouterModule } from '@angular/router';
import { iconMapping, TemplateListing } from '../../../models/manage-template.interface';
import { ROUTE_CONSTANTS } from '../../../util/route.constants';
import { CreatedBy } from '../../../models/template.model';
import { NotificationClassEnum } from '../../../models/notification-class.enum';
import { CVA_CONSTANTS } from '../../../util/constants';
import { CustomTemplateService } from '../../../services/custom-template/custom-template.service';
import { CVANotificationService } from '../../../services/cva-notification/cva-notification.service';

@Component({
    standalone: true,
    selector: 'cva-view-template',
    imports: [
        MatIconModule,
        MatButtonModule,
        DatePipe,
        MatMenuModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        RouterModule,
        NgClass
    ],
    styleUrl: './view-template.component.scss',
    templateUrl: './view-template.component.html'
})
export class ViewTemplateComponent {
  template: TemplateListing;
  templateContent: string;
  icon: string | undefined;
  isLoading: boolean = true;
  ROUTE = ROUTE_CONSTANTS.MANAGE_TEMPLATES + '/' + ROUTE_CONSTANTS.EDIT;
  CREATED_BY = CreatedBy;

  constructor(
    private readonly router: Router,
    private readonly customTemplateService: CustomTemplateService,
    private readonly cvaNotificationService: CVANotificationService,
    private readonly sanitizer: DomSanitizer,
    public matDialogRef: MatDialogRef<ViewTemplateComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly record: TemplateListing
  ) {
    this.template = record;
    this.icon = iconMapping[record.category]
    this.fetchTemplateContent(record.identifier)
  }

  fetchTemplateContent(id: string) {
    this.customTemplateService.getTemplateContentByTeamOrSelf(id)
      .subscribe({
        next: (data: { response: string }) => {
          if (data?.response) {
            this.templateContent = this.sanitizer.sanitize(SecurityContext.HTML, data.response.trim()) as string;
            this.isLoading = false;
          }
        },
        error: (e) => {
          this.isLoading = false;
          const errorMessage = e?.error?.error?.errorMessage || CVA_CONSTANTS.MESSAGE.UNABLE_TO_FETCH_RECORDS;
          console.log("Template content fetching process failed", errorMessage);
          this.cvaNotificationService.showNotification(
            errorMessage,
            NotificationClassEnum.ERROR
          );
        },
      });
  }

  goToEdit() {
    if (this.template.createdBy === CreatedBy.ME) {
      this.router.navigate([this.ROUTE, this.template.identifier]);
      this.matDialogRef.close();
    }
  }
}
